import React from "react";

function ShareIcons() {
  return (
    <span className="anticon ant-share">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        viewBox="0 0 20 17"
      >
        <path
          fill="transparent"
          stroke="currentColor"
          fillRule="nonzero"
          d="M1.151 16.134c.193.082.416.04.566-.105 2.567-2.478 5.941-3.894 9.551-4.019v3.644a.524.524 0 00.522.522.523.523 0 00.368-.153l7.305-7.305a.521.521 0 000-.738L12.158.676a.52.52 0 00-.89.369v3.664C5.468 4.982.833 9.787.833 15.654c0 .209.125.398.318.48z"
        ></path>
      </svg>
    </span>
  );
}

export default ShareIcons;
